import React, { useState } from 'react'
import ExperienceIcon from '../../assets/images/home/icons/dark-experience.svg'
import OutcomesIcon from '../../assets/images/home/icons/dark-outcomes.svg'
import ProductivityIcon from '../../assets/images/home/icons/dark-productivity.svg'
import PlayIcon from '../../assets/images/icons/pink-play.svg'
import { Modal } from '../Modal'
import { YoutubeVideo } from '../YoutubeVideo'
import Block from '../primitives/Block'
import Box from '../primitives/Box'
import Row from '../primitives/Row'
import Br from '../system/Br'
import Button from '../system/Button'
import DarkBlurb from '../system/DarkBlurb'

export const overviewMinusMargin = 48
export const overviewPaddingX = { xs: 10, xsm: 32, md: 64 } as const

export function OverviewBlock() {
  const [showVideo, setShowVideo] = useState(false)
  const toggleVideo = () => {
    setShowVideo(!showVideo)
  }
  return (
    <>
      {showVideo ? (
        <Modal
          onClose={() => setShowVideo(false)}
          // This is based on the video aspect ratio + modal paddings
          contentMaxWidth="calc(170vh - 84px)"
        >
          <YoutubeVideo
            videoId="ZHcQO20bL4w"
            autoplay={true}
            width="100%"
            borderRadius={0}
          />
        </Modal>
      ) : null}
      <Box
        backgroundColor="darkPurple"
        paddingTop={{ xs: 64, md: 92 }}
        borderTopLeftRadius={{ xs: 24, md: 48 }}
        borderTopRightRadius={{ xs: 24, md: 48 }}
        css={`
          margin-top: -${overviewMinusMargin}px;
        `}
        position="relative"
      >
        <Block maxWidth="largeBlock" paddingX={overviewPaddingX}>
          <Box paddingX={{ xs: 10, sm: 0 }}>
            <Box.h2
              font="h2"
              fontSize={{ xs: 28, sm: 32, md: 40, lg: 40 }}
              lineHeight={{ xs: '130%', sm: '120%' }}
              color="white"
              paddingBottom={{ xs: 16, sm: 20 }}
            >
              The engineering intelligence platform
            </Box.h2>
            <Box
              font="large"
              fontSize={{ xs: 18, sm: 20 }}
              color="white"
              paddingBottom={{ xs: 24, sm: 32 }}
            >
              Swarmia gives you the visibility and tools you need to improve
              across three key areas: <Br />
              business outcomes, developer productivity, and developer
              experience.
            </Box>
            <Row
              space={32}
              flexWrap="wrap"
              css={`
                /* When the content wraps the vertical spacing should be smaller */
                gap: 16px 32px;
              `}
            >
              <Button variant="leadLink" onClick={toggleVideo}>
                <Box.img
                  loading="lazy"
                  src={PlayIcon}
                  display="inline-block"
                  verticalAlign="middle"
                  paddingRight={8}
                />
                Watch product overview
              </Button>
              <Button
                arrow
                variant="leadLink"
                href="/product/"
                textAlign="center"
              >
                Explore more
              </Button>
            </Row>
          </Box>
          <Row
            paddingTop={{ xs: 24, sm: 64 }}
            paddingBottom={{ xs: 12, xsm: 16, md: 32 }}
            space={{ xs: 12, xsm: 16, md: 32 }}
            flexDirection={{ xs: 'column', md: 'row' }}
            alignItems="stretch"
          >
            <DarkBlurb
              title={
                <>
                  Drive planned <Br />
                  business outcomes
                </>
              }
              text="Make informed investment decisions and stay on top of strategic initiatives."
              icon={OutcomesIcon}
              href="/product/business-outcomes/"
            />
            <DarkBlurb
              title={
                <>
                  Systematically improve <Br />
                  developer productivity
                </>
              }
              text="Measure proven engineering metrics to identify and eliminate process bottlenecks."
              icon={ProductivityIcon}
              href="/product/developer-productivity/"
            />
            <DarkBlurb
              title={
                <>
                  Create a better <Br />
                  developer experience
                </>
              }
              text="Collect feedback from software engineers to improve developer experience."
              icon={ExperienceIcon}
              href="/product/developer-experience-surveys/"
            />
          </Row>
        </Block>
      </Box>
    </>
  )
}
